import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-midfreqimage',
  templateUrl: './midFreqImage.component.html',
  styleUrls: ['../../IconDesings.scss'],
})

export class MidFreqImageComponent {
  constructor() {
  }
}